/**
 * Planning et temps bloqué. Les absences (demande, « Mes absences ») et les
 * décisions ont leur espace depuis le 18/10/2026 : `features/absences`, `features/team`.
 */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';
import { PLANNING_READ_RIGHTS } from '../interventions/list/tabs.js';

const PlanningPage = lazy(() => import('./PlanningPage.js').then((m) => ({ default: m.PlanningPage })));
const NewInterventionPage = lazy(() => import('./NewInterventionPage.js').then((m) => ({ default: m.NewInterventionPage })));
const NewEventPage = lazy(() => import('./NewEventPage.js').then((m) => ({ default: m.NewEventPage })));
const GoogleCalendarPage = lazy(() => import('./GoogleCalendarPage.js').then((m) => ({ default: m.GoogleCalendarPage })));

export const planningRoutes: AppRoute[] = [
  { path: '/planning', element: <PlanningPage />, gate: { anyOf: PLANNING_READ_RIGHTS } },
  {
    path: '/planning/nouvelle-intervention',
    element: <NewInterventionPage />,
    gate: { anyOf: ['intervention.create_any', 'intervention.create_own'] },
  },
  { path: '/planning/bloquer-du-temps', element: <NewEventPage /> },
  { path: '/planning/temps-bloque/:id', element: <NewEventPage /> },
  { path: '/planning/google-agenda', element: <GoogleCalendarPage /> },
];
